import { auth } from "../config/firebase";
import LoadingSpinner from "../components/layout/LoadingSpinner";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Page, Role } from "@beyondrealityapp/core/shared/constants";
import { useEffect, useState } from "react";

type ProtectedRouteProps = {
  allowedRoles: string[];
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const location = useLocation();
  const [authResult, setAuthResult] = useState<
    Page.SIGN_IN | Page.HOME | Page.OUTLET | null
  >(null);

  useEffect(() => {
    const checkAuth = async () => {
      const idTokenResult = await auth.currentUser?.getIdTokenResult();

      // Check if roles defined, otherwise always redirect to login
      if (allowedRoles.length === 0) {
        setAuthResult(Page.SIGN_IN);
        return;
      }

      // Check if user is logged in, otherwise redirect to login
      const user = auth.currentUser;
      if (!user) {
        setAuthResult(Page.SIGN_IN);
        return;
      }

      // Check if user has admin role, otherwise redirect to home
      if (
        allowedRoles.indexOf(Role.USER) === -1 &&
        allowedRoles.indexOf(Role.ADMIN) >= 0 &&
        !idTokenResult?.claims.admin
      ) {
        setAuthResult(Page.HOME);
      } else {
        setAuthResult(Page.OUTLET);
        return;
      }
    };

    checkAuth();
  }, [allowedRoles]);

  if (authResult === null) {
    return <LoadingSpinner />;
  }

  if (authResult === Page.SIGN_IN) {
    // Sign-in returns here afterwards
    return (
      <Navigate
        to={Page.SIGN_IN}
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  if (authResult === Page.HOME) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
